import get from 'lodash/get'
import {createSelector} from 'reselect'

export const getProfile = (state) => get(state, ['data', 'profile', 'profile']);
export const getProfileLoaded = (state) => get(state, ['data', 'profile', 'loaded']);
export const getLoadingProfile = (state) => get(state, ['data', 'profile', 'loading']);
export const getProfileInformationCollected = createSelector(getProfile, (profile) => get(profile, ['information_collected']));
export const getContractorRole = createSelector(getProfile, (profile) => get(profile, ['contractor_details', 'contractor_role']));
export const getProfileName = createSelector(getProfile, (profile) => get(profile, ['name']));


// WEBPACK FOOTER //
// ./src/selectors/profile.js